export default __webpack_public_path__ + "static/blob8-69b67a6c8204ed39380015f06f73ebca.svg";